import moment from 'moment';
import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { getMABAA080AdminRegisterBanner, postMABAA080RecruitExpiredClone } from '../../../../services/Api';
import { formatDate, handleFocus } from '../../../../utils';
const PopupMABAA080_6 = ({ onClose, additionalData }) => {
    const { memberID, recruitSeq } = additionalData;
    const [popupDataComment, setPopupDataComment] = useState([]);
    const [popupDataCompanyName, setPopupDataCompanyName] = useState('');
    const [payload, setPayload] = useState({
        resultCode: '00',
        resultMsg: '정상',
        memberID,
        goodCode: '002',
        seq: recruitSeq,
        comment: '',
        actInputName: '',
        payment: 'Y',
    });

    useEffect(() => {
        getMABAA080AdminRegisterBanner({
            params: {
                memberID,
                recruitSeq,
            },
        })
            .then(({ data }) => {
                setPopupDataComment(data.comments);
                setPopupDataCompanyName(data.companyName);
            })
            .catch((error) => console.log(error));
    }, [memberID, recruitSeq]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'payment') {
            if (value === 'Y') {
                setPayload((prev) => ({
                    ...prev,
                    resultCode: '00',
                    resultMsg: '정상처리되었습니다',
                    payment: value,
                }));
            } else if (value === 'N') {
                setPayload((prev) => ({
                    ...prev,
                    resultCode: '',
                    resultMsg: '',
                    payment: value,
                }));
            }
        } else {
            setPayload((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };
    const formatDatePayload = (date) => {
        return moment(date).format('YYYY-MM-DD');
    };

    const handleSave = () => {
        if (payload.goodCode === '') {
            window.alert('배너상품명 입력해 주세요.');
            handleFocus('goodCode');
            return;
        }

        if (!payload.actInputName && payload.payment === 'Y') {
            window.alert('입금자명 입력해 주세요.');
            handleFocus('actInputName');
            return;
        }

        if (!payload.applDate && payload.payment === 'Y') {
            window.alert('결제일 입력해 주세요.');
            handleFocus('applDate');
            return;
        }

        if (!payload.recruitFrom) {
            window.alert('채용시작일 입력해 주세요.');
            handleFocus('recruitFrom');
            return;
        }

        if (!payload.recruitEnd) {
            window.alert('채용종료일 입력해 주세요.');
            handleFocus('recruitEnd');
            return;
        }

        if (!payload.comment) {
            window.alert('Comment 입력해 주세요.');
            handleFocus('comment');
            return;
        }

        const formattedRecruitFrom = formatDatePayload(payload.recruitFrom);
        const formattedRecruitEnd = formatDatePayload(payload.recruitEnd);
        const formattedApplyDate = formatDatePayload(payload.recruitEnd);

        delete payload.payment;

        const updatedPayload = {
            ...payload,
            recruitFrom: formattedRecruitFrom,
            recruitEnd: formattedRecruitEnd,
            applDate: formattedApplyDate,
            actInputName: payload.actInputName,
            comment: payload.comment,
        };

        postMABAA080RecruitExpiredClone(updatedPayload)
            .then(() => {
                alert('등록되었습니다.');
                onClose();
            })
            .catch((error) => console.log(error));
    };
    return (
        <div id="content">
            <div className="container">
                <div id="popup" data-popup="dental-information" className="dental-information">
                    <div className="overlay" />
                    <div className="popup-content">
                        <div className="popup-close" onClick={onClose} />
                        <div className="popup-header">[광고 등록]</div>
                        <div className="popup-title">마감된 채용광고 등록 - 신규등록</div>
                        <div className="table-dental-information">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>아이디</td>
                                        <td>{memberID}</td>
                                        <td>치과명</td>
                                        <td>{popupDataCompanyName}</td>
                                    </tr>
                                    <tr>
                                        <td>상품명</td>
                                        <td>
                                            <div className="select-box">
                                                <select name="goodCode" onChange={handleInputChange}>
                                                    <option value="">상품구분</option>
                                                    <option value="001">채용소식</option>
                                                    <option value="011">덴탈잡비즈니스배너(채용광고포함)</option>
                                                    <option value="002">덴탈잡그랜드배너(채용광고포함)</option>
                                                    <option value="003">덴탈잡프리미엄배너(채용광고포함)</option>
                                                    <option value="008">덴탈잡핫리쿠르트(채용광고포함)</option>
                                                    <option value="201">그랜드배너(체험)</option>
                                                    <option value="301">프리미엄배너(체험)</option>
                                                    <option value="801">핫리쿠르트(체험)</option>
                                                    <option value="R010">덴탈잡일반기업배너(채용광고포함)</option>
                                                    <option value="R111">일반기업배너(체험)</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td>입금자명</td>
                                        <td>
                                            <input type="text" name="actInputName" onChange={handleInputChange} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>결제여부</td>
                                        <td>
                                            <div className="select-box">
                                                <select name="payment" id="payment" onChange={handleInputChange}>
                                                    <option value="Y">결제</option>
                                                    <option value="N">미결제</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td>결제일</td>
                                        <td>
                                            <DatePicker
                                                onChange={(date) =>
                                                    handleInputChange({ target: { name: 'applDate', value: date } })
                                                }
                                                locale={'ko'}
                                                placeholderText={'YYYY/MM/DD'}
                                                dateFormat={'yyyy/MM/dd'}
                                                selected={payload.applDate}
                                                id="applDate"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>채용시작일</td>
                                        <td>
                                            <DatePicker
                                                onChange={(date) =>
                                                    handleInputChange({ target: { name: 'recruitFrom', value: date } })
                                                }
                                                locale={'ko'}
                                                placeholderText={'YYYY/MM/DD'}
                                                dateFormat={'yyyy/MM/dd'}
                                                selected={payload.recruitFrom}
                                                maxDate={payload.endDate || null}
                                                id="recruitFrom"
                                            />
                                        </td>
                                        <td>채용종료일</td>
                                        <td>
                                            <DatePicker
                                                onChange={(date) =>
                                                    handleInputChange({ target: { name: 'recruitEnd', value: date } })
                                                }
                                                locale={'ko'}
                                                placeholderText={'YYYY/MM/DD'}
                                                dateFormat={'yyyy/MM/dd'}
                                                selected={payload.recruitEnd}
                                                minDate={payload.recruitFrom || null}
                                                id="recruitEnd"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Comment</td>
                                        <td colSpan={3}>
                                            <textarea name="comment" onChange={handleInputChange} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="note-table">
                            ※ Comment 등록형식 : [상품명]/ [Comment] . ex) 프리미엄배너 / 전화가 안와요 불만)
                            <br />
                            ※ 새로운 채용광고로 등록됩니다. 기간연장은 재사용 버튼을 사용하세요.
                            <br />※ 상품명 중 덴탈잡이 포함된 상품은 유료상품입니다.
                        </div>
                        <div className="group-btn">
                            <button className="popup-button" onClick={handleSave}>
                                등록 / 수정
                            </button>
                        </div>
                        <div className="table-comment-results">
                            <div className="table-comment-results-title">
                                등록된 Comment (
                                {popupDataComment && popupDataComment.length > 0 ? popupDataComment.length : 0})
                            </div>
                            <table className="table-gray">
                                <thead>
                                    <tr>
                                        <th>Seq</th>
                                        <th>등록일</th>
                                        <th>관리자명</th>
                                        <th>등록사이트</th>
                                        <th>Comment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {popupDataComment && popupDataComment.length > 0 ? (
                                        popupDataComment.map((item) => (
                                            <tr key={item.seq}>
                                                <td>{item.seq}</td>
                                                <td>{formatDate(item.addDate)}</td>
                                                <td>{item.adminName}</td>
                                                <td>{item.sitePos}</td>
                                                <td>{item.comments}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={5} className="text-center">
                                                데이타가 없습니다.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PopupMABAA080_6;
